export const LANGUAGES = [
  { id: 'ca', value: 'common:languageCatalan' },
  { id: 'en', value: 'common:languageEnglish' },
  { id: 'es', value: 'common:languageSpanish' },
  { id: 'it', value: 'common:languageItalian' },
  { id: 'pt', value: 'common:languagePortuguese' },
  { id: 'fr', value: 'common:languageFrench' },
  { id: 'de', value: 'common:languageGerman' },
];
